var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcProgressDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0ZM11.0742 13.5723L8.24316 10.8086L7 12.0225L10.8887 15.8184L11.0742 16L12.3174 14.7852L17 10.2139L15.7568 9L11.0742 13.5723Z",
    fill: "#0021A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcProgressDone);
export default __webpack_public_path__ + "static/media/ic-progress-done.4dac87602de25dd538b1b260b4c287cf.svg";
export { ForwardRef as ReactComponent };